import { Container, Row, Col, Image } from "react-bootstrap";
import p_banner from "../assets/p_banner.png";
import p_shop_staff from "../assets/p_shop_staff.png";
import p_granny_kitchen from "../assets/p_granny_kitchen.png";
import p_family_dining from "../assets/p_family_dining.png";
import p_community_stall from "../assets/p_community_stall.png";
import { FaWhatsapp, FaPhone } from "react-icons/fa";

const AboutScreen = () => {
  const whatsappContact = "919390595210"
  const whatsappMessage = "Hi, I have the following enquiry.";
  const whatsappUrl = `https://wa.me/${whatsappContact}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <>
      {/* 🔷 TOP BANNER WITH GREY OVERLAY */}
      <div
        style={{
          backgroundImage: `url(${p_banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "320px",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* grey overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0, 0, 0, 0.55)", // darker overlay
          }}
        ></div>

        <h1
          className="display-4 fw-bold text-white"
          style={{ position: "relative", zIndex: 2, textShadow: "0 3px 8px rgba(0,0,0,0.7)" }}
        >
          Flavchap's Story
        </h1>
      </div>

      <Container className="py-4">

        {/* SECTION 1 */}
        <Row className="align-items-center my-5">
          <Col md={6}>
            <h2 className="mb-2">Fresh & tasty snacks and sweets</h2>
            <p>
              At Flavchap, we are committed to delivering fresh, tasty, traditional, high-quality snacks and sweets. We take pride in curating regional specialties with authenticity and care. Whether you're shopping for a festive occasion or a daily craving, we're here to serve you with excellence.
            </p>
          </Col>

          <Col md={6} className="text-center">
            <Image
              src={p_shop_staff}
              className="about-img"
              style={{ maxWidth: "420px", width: "100%" }}
              alt="Shop Staff"
            />
          </Col>
        </Row>

        {/* Decorative Line */}
        <hr className="my-4" />

        {/* SECTION 2 – image left */}
        <Row className="align-items-center my-5 flex-md-row-reverse">
          <Col md={6}>
            <h2 className="mb-3">Made with love & care</h2>
            <p>
              At Flavchap, our efforts are to bring you fresh, homemade, mouth-watering, authentic Telugu snacks and sweets. Our food items are not made in large commercial quantities, but in smaller homemade batches by people who have been preparing snacks for their own and others' families since many years. It's like your snack is made for you by a loved one. It's more than premium. It's priceless!
            </p>
          </Col>

          <Col md={6} className="text-center">
            <Image
              src={p_granny_kitchen}
              className="about-img"
              style={{ maxWidth: "420px", width: "100%" }}
              alt="Granny Kitchen"
            />
          </Col>
        </Row>

        <hr className="my-4" />

        {/* SECTION 3 */}
        <Row className="align-items-center my-5">
          <Col md={6}>
            <h2 className="mb-3">Enjoy with your loved ones</h2>
            <p>
              We believe in family values, and understand the need for great tasting snacks and sweets to be enjoyed together with your loved ones. Whether you are ordering in small quantities to enjoy a quick snack by yourself or with your loved ones, or whether you are ordering in large quantities for an occasion, we're here to serve you the best snacks and sweets.
            </p>
          </Col>

          <Col md={6} className="text-center">
            <Image
              src={p_family_dining}
              className="about-img"
              style={{ maxWidth: "420px", width: "100%" }}
              alt="Family Dining"
            />
          </Col>
        </Row>

        <hr className="my-4" />

        {/* SECTION 4 – image left */}
        <Row className="align-items-center my-5 flex-md-row-reverse">
          <Col md={6}>
            <h2 className="mb-3">Share with your community</h2>
            <p>
              We could also drop by at your community and setup a stall so that you could share our irresistible snacks and sweets with your larger community. After all, what else can spread joy faster and easier than a tasty snack!
            </p>
          </Col>

          <Col md={6} className="text-center">
            <Image
              src={p_community_stall}
              className="about-img"
              style={{ maxWidth: "420px", width: "100%" }}
              alt="Community Stall"
            />
          </Col>
        </Row>

        <hr className="my-4" />

        {/* SECTION 5 */}
        <Row className="justify-content-center text-center my-5">
          <Col md={6}>
            <h2 className="mb-3">Let us serve you. Contact Us.</h2>
            <h3>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                <FaWhatsapp style={{ color: 'green', fontSize: '3rem', fontStyle: "bold" }}/>
              </a>
              &nbsp;&nbsp;
              <a href="tel:+919390595210" style={{ textDecoration: 'none' }}>
                <FaPhone style={{ color: 'blue', fontSize: '3rem', fontStyle: 'bold' }} />{" "}
              </a>
            </h3>
          </Col>
        </Row>

        <hr className="my-4" />

      </Container>
    </>
  );
};

export default AboutScreen;